import React from 'react';
import SelectedArticles from './view/selectedArticles';

export const renderRule = {
  match: (item, cmsOption) => item.itemTypeCode === 'SelectedArticles', 
  itemElt: (item, cmsOption) => <SelectedArticles item={item} cmsOption={cmsOption} />
}